import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import CardCustom from '../../../components/custom/card-custom'
import TextNavTitle from '../../../components/TextNavTitle'
import NavTitle from '../../../components/nav-title'
import ProfileRight from '../../../components/setting/menu-right/profile-right'
import MenuRights from '../../../components/setting/menu-right/menu-right'
import SubmenuRight from '../../../components/setting/menu-right/submenu-right'
import CardRight from '../../../components/setting/menu-right/card-right'
import SubcardRight from '../../../components/setting/menu-right/subcard-right'
import { useSelector } from 'react-redux'

function MenuRight() {
  const [openSystem1, setOpenSystem1] = useState(false)
  const [openSystemChange, setOpenSystemChange] = useState(false)
  const [openSubMenu3, setOpenSupMenu3] = useState(false)
  const [openCard4, setOpenCard4] = useState(false)
  const [openSubCard5, setOpenSubCard5] = useState(false)
  const roleId = useSelector((state) => state.menuRightReducer.roleId)
  const menuId = useSelector((state) => state.menuRightReducer.menuId)
  const menuSubid = useSelector((state) => state.menuRightReducer.menuSubid)
  const cardId = useSelector((state) => state.menuRightReducer.cardId)
  useEffect(() => {
    setOpenSystemChange(false)
    setOpenSupMenu3(false)
    setOpenCard4(false)
    setOpenSubCard5(false)
  }, [roleId])

  useEffect(() => {
    setOpenCard4(false)
    setOpenSubCard5(false)
  }, [menuId])

  useEffect(() => {
    setOpenSubCard5(false)
  }, [menuSubid])

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Menu Right</TextNavTitle>
      </NavTitle>
      <Col xl={12}>
        <CardCustom border="0" className="mt-2">
          <div className="overflow-auto" style={{ height: '100vh' }}>
            <div className="bg-grey">
              <span
                className="col-12 d-flex justify-content-between bg-grey"
                style={{
                  padding: 20,
                  position: 'absolute'
                }}
              >
                <span className="col-2 text-center">Profile</span>
                <span className="col-2 text-center">Menu</span>
                <span className="col-2 text-center">Sub Menu</span>
                <span className="col-2 text-center">Card</span>
                <span className="col-4 text-center">Sub Card</span>
              </span>
            </div>

            <div className="col-12 mt-5 pt-4 d-flex small">
              {/* profile */}
              <ProfileRight
                openSystem1={openSystem1}
                setOpenSystem1={setOpenSystem1}
                openSystemChange={openSystemChange}
              />
              {/* menu */}
              <MenuRights
                openMenu2={openSystem1}
                openSubMenu3={openSubMenu3}
                setOpenSupMenu3={setOpenSupMenu3}
                roleId={roleId}
              />

              {/* sub menu */}
              <SubmenuRight
                openSubMenu3={openSubMenu3}
                openCard4={openCard4}
                setOpenCard4={setOpenCard4}
                roleId={roleId}
                menuId={menuId}
              />

              {/* card */}
              <CardRight
                openCard4={openCard4}
                openSubCard5={openSubCard5}
                setOpenSubCard5={setOpenSubCard5}
                roleId={roleId}
                menuId={menuId}
                menuSubid={menuSubid}
              />

              {/* sub card */}
              <SubcardRight
                openSubCard5={openSubCard5}
                roleId={roleId}
                menuId={menuId}
                menuSubid={menuSubid}
                cardId={cardId}
              />
            </div>
          </div>
        </CardCustom>
      </Col>
    </Row>
  )
}

export default MenuRight
